import { IconButton, Typography, CircularProgress } from "@mui/material";
import { Mic, MicOff, VolumeUp, VolumeOff } from "@mui/icons-material";
import classNames from "classnames";
import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "./PianoKeyboard.module.scss"
// import { useNotesMicrophoneDetect } from "../../hooks/useNotesMicrophoneDetect";
// import { useNotesMicrophoneDetect2 } from "../../hooks/useNotesMicrophoneDetect2";
// import { useNotesMicrophoneDetect3 } from "../../hooks/useNotesMicrophoneDetect3";
// import { useNotesMicrophoneDetect4 } from "../../hooks/useNotesMicrophoneDetect4";
// import { useNotesMicrophoneDetect5 } from "../../hooks/useNotesMicrophoneDetect5";
// import { useNotesMicrophoneDetect6 } from "../../hooks/useNotesMicrophoneDetect6";
import { useNotesMicrophoneDetect7 } from "../../hooks/useNotesMicrophoneDetect7";

interface IProps {
    range: [number, number];
    onPush: (keys: number[], muted?: boolean) => void;
    isMuted?: boolean;
    onToggleMute?: () => void;
}
export const DEFAUL_MIDI_KEY = 60;

export const PianoKeyboard: React.FC<IProps> = ({ range, onPush, isMuted, onToggleMute }) => {
    const [events, setEvents] = useState<Set<number>>(new Set())
    const lastPushRef = useRef('')
    const onPushRef= useRef(onPush); 
    const scrollContainerRef = useRef<HTMLDivElement>(null);
    
    useEffect(() => {
onPushRef.current = onPush
    }, [onPush])
    const { startListening, stopListening, isListening, isLoading } = useNotesMicrophoneDetect7({ onPush: (keys) => {
        const currentPush = keys.join(',')
        if (lastPushRef.current === currentPush) return
        lastPushRef.current = currentPush
        onPushRef.current(keys, true);
        setEvents(new Set(keys)) 
    } })

    useEffect(() => {
        return () => {
            stopListening()
        }
    }, [])

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (scrollContainerRef.current) {
                const defaultKey = document.getElementById(`piano_key_${DEFAUL_MIDI_KEY}`);
                if (defaultKey) {
                    const container = scrollContainerRef.current;
                    container.scrollLeft = defaultKey.offsetLeft - container.clientWidth / 2 + defaultKey.clientWidth / 2;
                }
            }
        }, 0);
        return () => clearTimeout(timeout);
    }, [range]);

    const Piano = useMemo(() => {
        const keysPattern = [0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 0, 1];
        let keyPatternCopy = [...keysPattern];
        const keys = []
        for (let i = 21; i <= 108; i++) {
            const min = Math.min(...range)
            const max = Math.max(...range)

            if (!keyPatternCopy.length) {
                keyPatternCopy = [...keysPattern]
            }
            const isBlack = keyPatternCopy.shift()
            if (i < min || i > max) {
                continue;
            }
            keys.push(
            <span key={`piano_button_${i}`}
                id={`piano_key_${i}`}
                className={classNames(styles.button, {
                    [styles.whiteButton]: !isBlack,
                    [styles.blackButton]: isBlack,
                    [styles.active]: events.has(i)
                })}
                style={{ touchAction: 'pan-x pan-y' }}
                onPointerDown={() => onPush([i])}
                onPointerUp={() => onPush([])}
                onPointerLeave={() => onPush([])}
                onPointerCancel={() => onPush([])}
                >
                <Typography color={'#808387'} sx={{ pointerEvents: 'none' }}>{i === DEFAUL_MIDI_KEY ? 'C' : ''}</Typography>
            </span>)
        }
        return keys;
    }, [onPush, events])
    return (
        <div className={styles.pianoWrapper} style={{ position: 'relative', width: '100%' }}>
            <div style={{ position: 'absolute', left: 0, top: 0, zIndex: 10, display: 'flex' }}>
                <IconButton disabled={isLoading} onClick={isListening ? stopListening : startListening}>
                    {isLoading ? <CircularProgress size={24} /> : isListening ? <Mic color="error" /> : <MicOff color="primary" />}
                </IconButton>
                {onToggleMute && (
                    <IconButton onClick={onToggleMute}>
                        {isMuted ? <VolumeOff color="error" /> : <VolumeUp color="primary" />}
                    </IconButton>
                )}
            </div>
            <div ref={scrollContainerRef} style={{ width: '100%', height: '100%', overflowX: 'auto', overflowY: 'hidden', display: 'flex', scrollBehavior: 'smooth' }}>
                <div style={{ display: 'flex', height: '100%', minWidth: 'max-content', margin: '0 auto', position: 'relative' }}>
                    {Piano}
                </div>
            </div>
        </div>
    )
}